export default __webpack_public_path__ + "static/media/ic_mail_outline_24px.d9cbfba9.svg";